<mat-card class="ddc-card-with-title">
  <mat-card-title>
    <span ddcLabel labelKey="{{_blockTitleLabelKey}}"></span>
  </mat-card-title>

  <mat-card-content>
    <div ddcLabel labelKey="{{_blockDescriptionLabelKey}}" class="ddc-appli-description link"></div>
      <div class="row">
        <div class="col-12">
          <button mat-raised-button class="ddc-button-primary ddc-button-right"
            (click)="displayDataToDeclare()"
            [disabled]="_isLoading"
          >
            {{isDataBlockDisplayed == false ? "Afficher les données à déclarer" : "Masquer les données"}}
          </button>
        </div>
      </div>
    <br/>

    <ng-container *ngIf="!_isLoading && isDataBlockDisplayed == true">
      <!-- Block concerning the general informations -->
      <div class="row" *ngFor="let informationGenerales of _donneesDeclarationTam.informationsGenerales">
        <ng-container *ngFor="let information of informationGenerales">
          <div class="{{information.class}} ddc-avis">
            <div class="ddc-read-only-data-container">
              <span class="ddc-label" ddcLabel labelKey="{{information.labelKey}}"></span>:
              <span class="ddc-value">{{information.value}}</span>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Block concerning the total tam ref fonctions and qualités -->
      <div class="row">
        <div class="col-12">
          <ng-container *ngIf="_donneesDeclarationTamTotals?.length > 0;">
              <div ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.title" class="ddc-title-table"></div>
              <table mat-table [dataSource]="_donneesDeclarationTamTotals">
                <ng-container matColumnDef="headerFonction">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" class="header-group header-group-separator">
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.fonction"></span>
                        <span >
                            (total {{_donneesDeclarationTamTotals[0].totalAdherents}})
                        </span>
                    </th>
                </ng-container>

                <ng-container matColumnDef="headerQualite">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="header-group">
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.qualite.title"></span>
                    </th>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['headerFonction', 'headerQualite']" class="header-row-small"></tr>
                <tr mat-header-row *matHeaderRowDef="_donneesDeclarationTamTotalsColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: _donneesDeclarationTamTotalsColumns"></tr>
                <ng-container matColumnDef="totalDirecteurs">
                    <th mat-header-cell *matHeaderCellDef>
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.directeur"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalDirecteurs}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalAdjoints">
                    <th mat-header-cell *matHeaderCellDef>
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.adjoint"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalAdjoints}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalAnimateurs">
                    <th mat-header-cell *matHeaderCellDef>
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.animateur"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalAnimateurs}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalAutres">
                    <th mat-header-cell *matHeaderCellDef class="header-group-separator">
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.autre"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalAutres}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalTitulaires">
                    <th mat-header-cell *matHeaderCellDef>
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.titulaire"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalTitulaires}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalStagiaires">
                    <th mat-header-cell *matHeaderCellDef>
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.stagiaire"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalStagiaires}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalNonQualifies">
                    <th mat-header-cell *matHeaderCellDef>
                        <span ddcLabel labelKey="appli.projetAnnee.onglet.ficheComplementaire.donneesDeclarer.intervenant.recap.nonQualifie"></span>
                    </th>
                    <td mat-cell *matCellDef="let total">
                        {{total.totalNonQualifies}}
                    </td>
                </ng-container>
              </table>
          </ng-container>
        </div>
      </div>

      <!-- Table staff -->
      <ng-container *ngIf="_donneesDeclarationTam.intervenants">
        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="_donneesDeclarationTam.intervenants && _donneesDeclarationTam.intervenants.length > 0; else noIntervenantBlock">
              <div ddcLabel labelKey="appli.camp.onglet.suiviDDCS.donneesDeclarer.intervenantDeclarerTitre" class="ddc-title-table"></div>

              <table mat-table matSort [dataSource]="_donneesDeclarationTam.intervenants" [matSortActive]="sortActive" [matSortDirection]="sortDirection" (matSortChange)="sortData($event, TableDonneeDeclarerDDCSEnum.INTERVENANT)">
                <ng-container  *ngFor="let column of _donneesDeclarationTam.intervenantsTableDisplayedColumns" matColumnDef="{{column}}">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    <span ddcLabel labelKey="{{_donneesDeclarationTam.intervenantLabelKeys[column]}}"></span>
                  </th>
                  <td mat-cell *matCellDef="let intervenant">
                    <span [innerHTML]="intervenant[column]"></span>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="_donneesDeclarationTam.intervenantsTableDisplayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: _donneesDeclarationTam.intervenantsTableDisplayedColumns;"></tr>
              </table>
            </ng-container>
            <ng-template #noIntervenantBlock>
              <div class="ddc-warning-message">
                <span class="material-icons">info</span>
                <span ddcLabel labelKey="appli.camp.onglet.suiviDDCS.donneesDeclarer.nonIntervenant"></span>
              </div>
            </ng-template>
          </div>
        </div>
        <br/>
      </ng-container>

      <!-- Table staff -->
      <ng-container *ngIf="_donneesDeclarationTamToDo.intervenants">

        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="_donneesDeclarationTamToDo.intervenants && _donneesDeclarationTamToDo.intervenants.length > 0; else noIntervenantBlock">
              <div ddcLabel labelKey="appli.camp.onglet.suiviDDCS.donneesDeclarer.nonIntervenantPasDeclarerTitre" class="ddc-title-table"></div>

              <table mat-table matSort [dataSource]="_donneesDeclarationTamToDo.intervenants" [matSortActive]="sortActive" [matSortDirection]="sortDirection" (matSortChange)="sortData($event, TableDonneeDeclarerDDCSEnum.INTERVENANT_TO_DO)">
                <ng-container *ngFor="let column of _donneesDeclarationTamToDo.intervenantsTableDisplayedColumns" matColumnDef="{{column}}">
                  <th mat-sort-header id="ddc-header-table-adherent" mat-header-cell *matHeaderCellDef>
                    <span ddcLabel labelKey="{{_donneesDeclarationTamToDo.intervenantLabelKeys[column]}}"></span>
                  </th>
                  <td mat-cell *matCellDef="let intervenant">
                    <span [innerHTML]="intervenant[column]"></span>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="_donneesDeclarationTamToDo.intervenantsTableDisplayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: _donneesDeclarationTamToDo.intervenantsTableDisplayedColumns;"></tr>
              </table>
            </ng-container>
            <ng-template #noIntervenantBlock>
              <div class="ddc-warning-message">
                <span class="material-icons">info</span>
                <span ddcLabel labelKey="appli.camp.onglet.suiviDDCS.donneesDeclarer.nonIntervenantPasDeclarer"></span>
              </div>
            </ng-template>
          </div>
        </div>
        <br/>
      </ng-container>

      <!-- Table lieu -->
      <ng-container *ngIf="_donneesDeclarationTam.lieux">
        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="_donneesDeclarationTam.lieux && _donneesDeclarationTam.lieux.length > 0; else noLieuxBlock">
              <div ddcLabel labelKey="appli.camp.onglet.suiviDDCS.donneesDeclarer.lieuTitre" class="ddc-title-table"></div>

              <table matSort mat-table [dataSource]="_donneesDeclarationTam.lieux" [matSortActive]="sortActive" [matSortDirection]="sortDirection" (matSortChange)="sortData($event, TableDonneeDeclarerDDCSEnum.LIEUX)">
                  <ng-container *ngFor = "let column of _donneesDeclarationTam.lieuxTableDisplayedColumns" matColumnDef="{{column}}">
                    <th mat-sort-header mat-header-cell *matHeaderCellDef>
                      <span ddcLabel labelKey="{{_donneesDeclarationTam.lieuLabelKeys[column]}}"></span>
                    </th>
                    <td mat-cell *matCellDef="let lieu">
                      <span [innerHTML]="lieu[column]"></span>
                    </td>
                  </ng-container>
                <tr mat-header-row *matHeaderRowDef="_donneesDeclarationTam.lieuxTableDisplayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: _donneesDeclarationTam.lieuxTableDisplayedColumns; let i = index"></tr>
              </table>
            </ng-container>
            <ng-template #noLieuxBlock>
              <div class="ddc-warning-message">
                <span class="material-icons">info</span>
                <span ddcLabel labelKey="appli.camp.onglet.suiviDDCS.donneesDeclarer.nonLieux"></span>
              </div>
            </ng-template>
          </div>
        </div>
        <br/>
      </ng-container>

      <!-- Block Responsable (Personne à prévenir en cas d'urgence) -->
      <ng-container *ngIf="_donneesDeclarationTam.adherentResponsable; else noAdherentResponsable">
        <mat-card class="ddc-subcard-with-title">
          <mat-card-title>
            <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentResponsable.title"></span> : {{_donneesDeclarationTam.adherentResponsable.prenomCivil ? _donneesDeclarationTam.adherentResponsable.prenomCivil : _donneesDeclarationTam.adherentResponsable.prenom}} {{_donneesDeclarationTam.adherentResponsable.nom}}
          </mat-card-title>
          <mat-card-content>
            <div class="row">
              <div class="col-6 ddc-padding-vertical">
                <div class="ddc-read-only-data-container">
                  <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentResponsable.email"></span>&nbsp;
                  <span class="ddc-value">{{_donneesDeclarationTam.adherentResponsable.email}}</span>
                </div>
              </div>
              <div class="col-3 ddc-padding-vertical">
                <div class="ddc-read-only-data-container">
                  <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentResponsable.telephonePortable"></span>&nbsp;
                  <span class="ddc-value">{{_donneesDeclarationTam.adherentResponsable.telephonePortable}}</span>
                </div>
              </div>
              <div class="col-3 ddc-padding-vertical">
                <div class="ddc-read-only-data-container">
                  <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentResponsable.telephoneLieu"></span>&nbsp;
                  <span class="ddc-value">{{_donneesDeclarationTam.adherentResponsable.telephoneLieu}}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <br/>
      </ng-container>
      <ng-template #noAdherentResponsable>
        <div class="ddc-warning-message">
          <div class="row">
            <div class="col-12">
              <span class="material-icons">info</span>
              <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentResponsable.noAdherentResponsable"></span>
            </div>
          </div>
        </div>
        <br/>
      </ng-template>

      <!-- Block Declarant -->
      <ng-container *ngIf="_donneesDeclarationTam.adherentDeclarant; else noAdherentDeclarant">
        <mat-card class="ddc-subcard-with-title">
          <mat-card-title>
            <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentDeclarant.title"></span> : {{_donneesDeclarationTam.adherentDeclarant.prenomCivil ? _donneesDeclarationTam.adherentDeclarant.prenomCivil : _donneesDeclarationTam.adherentDeclarant.prenom}} {{_donneesDeclarationTam.adherentDeclarant.nom}}
          </mat-card-title>
          <mat-card-content>
            <div class="row">
              <div class="col-3 ddc-padding-vertical">
                <div class="ddc-read-only-data-container">
                  <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentDeclarant.fonction"></span>&nbsp;
                  <span class="ddc-value">{{_donneesDeclarationTam.adherentDeclarant.fonction ? _donneesDeclarationTam.adherentDeclarant.fonction[0]?.libelle : ''}}</span>
                </div>
              </div>
              <div class="col-6 ddc-padding-vertical">
                <div class="ddc-read-only-data-container">
                  <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentDeclarant.lieuNaissance"></span>&nbsp;
                  <span class="ddc-value">{{_donneesDeclarationTam.adherentDeclarant.lieuNaissance}}</span>&nbsp;
                  <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentDeclarant.dateNaissance"></span>&nbsp;
                  <span class="ddc-value">{{convertToHumanDate(_donneesDeclarationTam.adherentDeclarant.dateNaissance)}}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <br/>
      </ng-container>
      <ng-template #noAdherentDeclarant>
        <div class="ddc-warning-message">
          <div class="row">
            <div class="col-12">
              <span class="material-icons">info</span>
              <span ddcLabel labelKey="appli.shared.donneesDeclaration.adherentDeclarant.noAdherentDeclarant"></span>
            </div>
          </div>
        </div>
        <br/>
      </ng-template>

    </ng-container>

  </mat-card-content>

</mat-card>
